module.exports = __webpack_public_path__ + "static/img/cab-IRs.b49c954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/cab/cab-IRs.jpg
// module id = DTUQ
// module chunks = 12